import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { headquarterStorage } from 'src/app/models/headquarter/headquarterStorage';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { EmitterService } from 'src/app/shared/services/emitter.service';
import { MessageModalComponent } from '../../message/message-modal.component';
import { storageFileDirectory } from 'src/app/models/storage/storageFileDirectory';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-headquarter-storage-modal',
  templateUrl: './headquarter-storage-modal.component.html',
  styleUrls: ['./headquarter-storage-modal.component.css']
})
export class HeadquarterStorageModalComponent implements OnInit {
  fileForm: FormGroup
  title: string;
  loading: boolean = false;
  isAdminGys: boolean = false;
  sessionUserId: string;
  storageFileSelect: number = 1;
  directoryTypeSelect: number = 1;
  storageTypeSelect: number = 1;
  storageTypeSelect2: number = 1;
  listFiles: Array<storageFileDirectory>;
  listFilesInit: Array<storageFileDirectory>;
  arrayData: headquarterStorage[];

  constructor(
    public dialogRef: MatDialogRef<HeadquarterStorageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private storageService: StorageService,
    private alertService: AlertService,
    private emitterService: EmitterService) { }

  ngOnInit() {
    this.isAdminGys = (+localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.AdministradorGyS || +localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.UsuarioGyS) ? true : false;
    this.sessionUserId = localStorage.getItem(AppConstants.Session.USERID);
    this.createForm();
    this.getData();
  }

  changeDirectory(data){
    if(data.value == 1){
      this.listFiles = this.listFilesInit.filter(x => x.blobStorage == 1 && x.isHeadquarter == 1);
    }else if(data.value == 2){
      this.listFiles = this.listFilesInit.filter(x => x.dataLakeStorage == 1 && x.isHeadquarter == 1);
    }
  }

  getData() {
    this.spinner.show();
    this.storageService.get(this.data.idEnterprise,this.data.idHeadquarter).subscribe((response => {
      if(response.error == null && response.data != null){
        console.log(response);
        this.listFilesInit = response.data.fileDirectories;
        this.listFiles = response.data.fileDirectories.filter(x => x.blobStorage == 1 && x.isHeadquarter == 1);
        this.storageTypeSelect = response.data.idStorageType;
        this.storageTypeSelect2 = response.data.idStorageType2;
        this.fileForm.patchValue({
          idStorageType: response.data.idStorageType,
          storagePath: response.data.storagePath,
          idStorageType2: response.data.idStorageType2,
          storagePath2: response.data.storagePath2,
          dataLakePath: response.data.dataLakePath,
        });
      }
      this.spinner.hide();
    }),
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  createForm() {
    this.fileForm = this.formBuilder.group({
        idDirectoryType: [1,[Validators.required]],
        idStorageType: [0,[Validators.required]],
        storagePath: [''],
        idStorageType2: [0],
        storagePath2: [''],
        dataLakePath: ['']
    });
  }

  get f() { return this.fileForm.controls; }

  openConfirmationModal() {
    if (this.fileForm.valid) {
      let dialogRef = this.dialog.open(MessageModalComponent, {
          data: {
              title: AppConstants.TitleModal.UPDATE_HEADQUARTER_FILE,
              message: AppConstants.MessageModal.UPDATE_MESSAGE_ENTERPRISE_SETTING_CONFIRM,
              hasButton: true,
              contentButton: {
                  yes: 'SI',
                  no: 'CANCELAR'
              }
          },
      });

      dialogRef.afterClosed().subscribe(response => {
          if (response.result == true) {
            this.update();
          }
      });

    } else {
      this.fileForm.markAllAsTouched();
    }
  }

  update() {

    if(this.fileForm.valid){

      this.listFilesInit.forEach(obj => {
        obj.idEnterprise = this.data.idEnterprise;
        obj.idHeadquarter = this.data.idHeadquarter;
      });

      var data = {
        idEnterprise: this.data.idEnterprise,
        idHeadquarter: this.data.idHeadquarter,
        idStorageType: this.fileForm.value["idStorageType"],
        idStorageType2: this.fileForm.value["idStorageType2"],
        storagePath: this.fileForm.value["storagePath"],
        storagePath2: this.fileForm.value["storagePath2"],
        dataLakePath: this.fileForm.value["dataLakePath"],
        fileDirectories: this.listFilesInit,
        isDirectoryHeadquarter: 1
      }
      this.spinner.show();
      this.storageService.update(data).subscribe((response => {
        this.alertService.showMessage("", AppConstants.MessageModal.UPDATE_ENTERPRISE_SETTING, MessageSeverity.success);
        this.spinner.hide();
        this.data.result = true;
        this.dialogRef.close(this.data);
      }),
        (error: HttpErrorResponse) => {
          this.alertService.showMessage("", error.error.messages, MessageSeverity.error);
          this.spinner.hide();
        });
    }else{
      this.fileForm.markAllAsTouched();
      this.alertService.showMessage("", AppConstants.MessageModal, MessageSeverity.error);
    }
  }

  close() {
    this.dialog.closeAll();
  }

  changeValue(item,event:any){
    this.listFilesInit.forEach(obj => {
      if(obj.idFileDirectory==item.idFileDirectory){
        obj.name = event.target.value;
      }
    });
    console.log('files',this.listFilesInit);
  }
}
